/* ACKNOWLEDGEMENT
 * ref: https://stackoverflow.com/a/61719846
 */
import { createRef, useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top
 * @param {number} throttleMilliseconds - Throttle observable listener, in ms
 */
const useVisibility = (
    offset = 0,
    throttleMilliseconds = 100
) => {
    const [isVisible, setIsVisible] = useState(false);
    const currentElement = createRef();

    const onScroll = throttle(() => {
        if (!currentElement.current) {
            setIsVisible(false);
            return;
        }

        const top = currentElement.current.getBoundingClientRect().top;

        /*
        * above = top + offset >= 0
        * below = top - offset <= window.innerHeight
        * setIsVisible(above && below);
        */
        setIsVisible(top - offset <= window.innerHeight);
    }, throttleMilliseconds);

    useEffect(() => {
        // needed for reloading
        onScroll();

        document.addEventListener('scroll', onScroll);
        return () => document.removeEventListener('scroll', onScroll);
    });

    return [isVisible, currentElement];
};

export default useVisibility;
